import './new-travel-voucher.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormTravelVoucher from "../form-travel-voucher/form-travel-voucher";
import { useNewTravelVoucher } from './new-travel-voucher.hook';

export function NewTravelVoucher() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewTravelVoucher();

  return (
    <div id="NewTravelVoucher" className="travel-voucher">
      <HeaderContent
        title={<h1>New Travel Voucher</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormTravelVoucher />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewTravelVoucher;